module.exports = __webpack_public_path__ + "static/img/guan4.e81b84d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/guan4.jpeg
// module id = bt/x
// module chunks = 36